/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
// import Routes from "../../../routes";
import Layoutcursos from "../../Layout/Cursoslayout";
import './Endodontia.css';

const Endodontia = () => {

    return(
        <>
            <Layoutcursos>
            </Layoutcursos>
            <img src="/images/professores/conceicaoaparecida.png" className="img-endodontia" alt="professor"></img>
                <div className="conteudopublico">
                    <p> CIRURGIÕES-DENTISTAS </p>
                </div>
                <div className="conteudodiferenciais">
                    <p>     - TECNOLOGIAS AVANÇADAS APLICADAS A ENDODONTIA
                            (INSTRUMENTAÇÃO MECANIZADA,LOCALIZADOR ELETRÔNICO,ULTRASSOM);<br/>
                            - PRÁTICAS COM RADIOGRAFIA DIGITAL E TOMOGRAFIA COMPUTADORIZADA POR FEIXE CÔNICO; <br/>
                            - PRÁTICAS INTEGRATIVAS COMPLEMENTARES EM SAÚDE, INCLUINDO OZONIOTERAPIA;<br/>
                            - ESTRUTURA FÍSICA MODERNA E INOVADORA.<br/>
                    </p>
                    
                </div>
                <div className="professor">
                    <p id="prof">PROFª.</p><br/>
                    <strong id="coordenacao">Conceição Aparecida Dornelas Monteiro Maia</strong><br/><br/>
    
                    <p className="curriculo">Formada em Odontologia pela UFPB, Especialista em Endodontia 
                                                pela FOP/UPE e em Radiologia Odontológica e Imaginologia UNIPÊ/PB. 
                                                Possui Mestrado em Clínicas Odontológicas pela UnP e Doutorado em 
                                                Patologia Oral pela UFRN. Atualmente é docente do Curso de Odontologia 
                                                do UNIFACEX Possui grande experiência profissional na área do ensino 
                                                odontológico e da Endodontia.
                    </p>
                    <br/> <div className="convidados">
                    <strong>CONVIDADOS</strong><br/>                                
                    <details>
                        <small>
                            ALBERTO CONSOLARO – SÃO PAULO/SP <br/>
                            REJANE ANDRADE DE CARVALHO – NATAL/RN <br/>
                            ROSÂNGELA LUSTOSA D’ÁVILA PINHEIRO DANIEL – NATAL/RN <br/>
                            JOVANKA ÚLTIMA MARINHO – NATAL/RN <br/>
                            MARINA C. LEMMOS LOPES CARDOSO – NATAL/RN <br/>
                            HANIERI GUSTAVO DE OLIVEIRA – NATAL/RN
                        </small>
                    </details>
                    </div><br/>
                    <div className="professores">
                    <strong>PROFESSORES</strong><br/>                                
                        <details>
                            {/* <summary> PROFESSORES </summary> */}
                            <small>
                                DÉBORA MICHELLE GONÇALVES DE AMORIM<br/>
                                LUCIANA GUERRA BRANDÃO LYRA <br/>
                                CÍCERO ROMÃO GADÊ NETO <br/>
                            </small>
                        </details><br/><br/> 
                    </div>  
                         
                </div>
                <div id="tipodepagamento">
                    <p className="encontro-conteudo">MENSALMENTE | QUARTA A SÁBADO</p>
                    {/* <small className="encontro-horarios">8H ÀS 12H E DAS 13H30 DAS 17H30</small> */}
                    <p className="cargahoraria-conteudo">855 HORAS</p>
                    <p className="tipoaula-conteudo">PRESENCIAL </p>
                    <p className="parcelas">24X</p>
                    <p className="R">R$</p>
                    <h1 className="valor">1.300,00</h1>
                    <p className="pagamento-info">PAGAMENTO NO CARTÃO OU NO BOLETO ATÉ A DATA DO VENCIMENTO</p>
                </div>
                <div>
                    <strong className="titulo-curso">ESPECIALIZAÇÃO EM ENDODONTIA</strong>   
                </div>
                <div className="conteudo-curso">
                    <p>
                        A Endodontia é a especialidade que objetiva preservar o dente através da prevenção, diagnóstico, prognóstico, tratamento e controle das alterações da polpa e dos tecidos perirradiculares.
                        É uma das áreas da Odontologia que recebe constantemente novidades em recursos tecnológicos otimizando, assim, a terapia endodôntica sempre baseada em evidências científicas.
                        O aluno da ESPECIALIZAÇÃO EM ENDODONTIA será capacitado a diagnosticar e traçar estratégias de tratamento e retratamento, praticando uma endodontia automatizada aliada a outros recursos, incluindo diagnóstico por imagem como: radiografia digital e tomografia computadorizada por feixe cônico realizados no UNIFACEX.
                        ESSA OPORTUNIDADE É PARA VOCÊ QUE DESEJA SE TORNAR UM PROFISSIONAL DE EXCELÊNCIA NA ÁREA DA ENDODONTIA!
                        JUNTE-SE A NÓS!!!
                    </p>
                </div>
                <a href={`${process.env.PUBLIC_URL}/Files/pdf/Matriz-Endodontia.pdf`} rel="noreferrer" target='_blank' download><button className="Matriz" ><h4>MATRIZ CURRICULAR</h4></button></a>
            
        </>
    );

};

export default Endodontia;